function ArrowUp({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path
        d="M6.78339 13.7854L5.81738 12.8194L11.0001 7.63672L16.1827 12.8194L15.2167 13.7854L11.0001 9.56871L6.78339 13.7854Z"
        fill="#616161"
      />
    </svg>
  );
}

export default ArrowUp;
